export default __webpack_public_path__ + "static/media/undrawEmail.2fd79e77.png";